<template>
  <div
    class="inline-image-cropper"
    :class="{
      'inline-image-cropper--hidden': !visible,
      'inline-image-cropper--loading': visible && !imgWidth
    }"
  >
    <div class="image-crop-modal__container" :style="containerStyle">
      <div :style="effectStyle" class="inline-image-cropper__container">
        <img
          v-if="imageSrc"
          :src="imageSrc"
          @load="handleImageLoad"
          class="inline-image-cropper__image"
          :style="imageStyle"
        />
        <div
          class="image-crop-modal__cropper"
          ref="cropper"
          :style="cropperStyle"
          @mousedown="handleMouseDown"
        >
          <template v-for="vd in ['t', 'b']">
            <div
              v-for="hd in ['r', 'l']"
              :key="vd + hd"
              :class="[
                'effect-cover__handle',
                'effect-cover__handle--' + vd + hd
              ]"
              :style="{ cursor: getResizeCursor(vd + hd), margin: '-6px' }"
              @mousedown.stop="handleMouseDown($event, vd + hd)"
            />
          </template>
        </div>
        <div class="image-crop-modal__spinner">
          <a-icon type="loading" />
        </div>
      </div>
      <div class="inline-image-cropper__controls" :style="controlStyle">
        <el-slider
          v-model="zoom"
          :min="minZoom"
          :max="maxZoom"
          class="slide-zoomer__zoom"
          :formatTooltip="formatTooltip"
        />
        <el-tooltip content="完成 (Enter)">
          <a-button
            type="link"
            class="ant-btn-icon-only inline-image-cropper__btn"
            @click="done"
          >
            <span class="anticon">
              <span class="el-icon-check" />
            </span>
          </a-button>
        </el-tooltip>
        <el-tooltip content="取消 (Esc)">
          <a-button
            type="link"
            class="ant-btn-icon-only inline-image-cropper__btn"
            @click="cancel"
          >
            <span class="anticon">
              <span class="el-icon-close" />
            </span>
          </a-button>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { clamp, getEffectBoxStyle, getVideoDuration, rotateBy } from '../../utils';

export default {
  // TODO: image may be rotated or flipped.
  data() {
    return {
      x: 0,
      y: 0,
      w: 0,
      h: 0,
      top: 0,
      left: 0,
      width: 0,
      height: 0,
      imgWidth: 0,
      imgHeight: 0,
      offset: null,
      moveOffset: {
        x: 0,
        y: 0
      },
      containerStyle: {},
      containerOffset: 0,
      videoDuration: 0,
      dragging: false
    };
  },
  computed: {
    ...mapState(['clippingEffect']),
    ...mapGetters(['activeFragment']),
    visible() {
      return this.$store.state.clipping;
    },
    scale() {
      return this.$store.state.playerScale / 100;
    },
    containerEffect() {
      return (this.clippingEffect
        && this.clippingEffect.container
        && this.$store.state.effects[this.clippingEffect.container]
      ) || null;
    },
    value() {
      return this.clippingEffect && this.clippingEffect.content.clip;
    },
    effectStyle() {
      label: if (this.clippingEffect) {
        if (this.activeFragment.background === this.clippingEffect.id) {
          break label;
        }
        if (!this.clippingEffect.locked) {
          const efc = {
            ...this.clippingEffect.content,
            top: this.top,
            left: this.left,
            width: this.width,
            height: this.height
          };
          const effectCopy = {
            ...this.clippingEffect,
            content: efc
          };
          if (this.containerEffect) {
            const containerEFC = this.containerEffect.content;
            const containerCenter = { x: containerEFC.width / 2, y: containerEFC.height / 2 };
            const selfCenter = { x: efc.left + efc.width / 2, y: efc.top + efc.height / 2 };

            let rotate = efc.rotate;

            switch (containerEFC.flip) {
              case 'horizontal':
                selfCenter.x = containerEFC.width - selfCenter.x;
                rotate = -rotate;
                break;
              case 'vertical':
                selfCenter.y = containerEFC.height - selfCenter.y;
                rotate = -rotate;
                break;
            }

            const { x, y } = rotateBy(selfCenter, containerCenter, containerEFC.rotate);
            effectCopy.content = {
              ...efc,
              top: y + containerEFC.top - efc.height / 2,
              left: x + containerEFC.left - efc.width / 2,
              rotate: rotate + containerEFC.rotate
            };
          }
          let ret = getEffectBoxStyle(effectCopy);

          ['left', 'top', 'width', 'height'].forEach(key => {
            ret[key] = parseFloat(ret[key]) * this.scale + 'px';
          });
          return ret;
        }
      }
      return {
        display: 'none'
      };
    },
    cropperStyle() {
      const ret = {
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        cursor: this.dragging ? this.dragging.dir ? 'default' : 'grabbing' : 'grab'
      };
      if (this.offset) {
        ret.top = this.offset.y * this.scale;
        ret.left = this.offset.x * this.scale;
        ret.width = this.offset.w * this.scale + 'px';
        ret.height = this.offset.h * this.scale + 'px';
      }
      return {
        top: ret.top + 'px',
        left: ret.left + 'px',
        width: ret.width,
        height: ret.height
      };
    },
    resetMarker() {
      return [].concat(
        this.visible,
        this.value ? [this.value.x, this.value.y, this.value.w, this.value.h] : []
      ).join(',');
    },
    imageStyle() {
      if (this.imgWidth && this.imgHeight) {
        console.log(this.imgWidth);
        return {
          top: (-this.y / this.h * this.height + this.moveOffset.y) * this.scale + 'px',
          left: (-this.x / this.w * this.width + this.moveOffset.x) * this.scale + 'px',
          width: this.imgWidth / this.w * 100 + '%',
          height: this.imgHeight / this.h * 100 + '%'
        };
      }
      return {};
    },
    controlStyle() {
      label: if (this.clippingEffect) {
        if (this.activeFragment.background === this.clippingEffect.id) {
          break label;
        }
        if (!this.clippingEffect.locked) {
          const efc = {
            ...this.clippingEffect.content,
            top: this.top,
            left: this.left,
            width: this.width,
            height: this.height
          };
          const effectCopy = {
            ...this.clippingEffect,
            content: efc
          };
          if (this.containerEffect) {
            const containerEFC = this.containerEffect.content;
            const containerCenter = { x: containerEFC.width / 2, y: containerEFC.height / 2 };
            const selfCenter = { x: efc.left + efc.width / 2, y: efc.top + efc.height / 2 };

            let rotate = efc.rotate;

            switch (containerEFC.flip) {
              case 'horizontal':
                selfCenter.x = containerEFC.width - selfCenter.x;
                rotate = -rotate;
                break;
              case 'vertical':
                selfCenter.y = containerEFC.height - selfCenter.y;
                rotate = -rotate;
                break;
            }

            const { x, y } = rotateBy(selfCenter, containerCenter, containerEFC.rotate);
            effectCopy.content = {
              ...efc,
              top: y + containerEFC.top - efc.height / 2,
              left: x + containerEFC.left - efc.width / 2,
              rotate: rotate + containerEFC.rotate
            };
          }
          const { left, top, width, height, rotate } = effectCopy.content;
          const pts = [{ x: left, y: top }, { x: left + width, y: top }, { x: left + width, y: top + height }, { x: left, y: top + height }].map((pt) => {
            return rotateBy(pt, { x: left + width / 2, y: top + height / 2 }, rotate);
          });
          const ypos = Math.min.apply(Math, pts.map(pt => pt.y)) * this.scale;
          const xs = pts.map(pt => pt.x);
          const xpos = (Math.min.apply(Math, xs) + Math.max.apply(Math, xs)) / 2 * this.scale;

          return {
            top: Math.max(ypos - 48, 8 - this.containerOffset) + 'px',
            left: xpos - 160 + 'px'
          };
        }
      }
      return {
        display: 'none'
      };
    },
    zoom: {
      get() {
        return this.imgWidth / this.w * 100;
      },
      set(value) {
        const actualValue = value / 100;
        if (actualValue) {
          const prevW = this.w;
          const prevH = this.h;
          this.w = this.imgWidth / actualValue;
          this.h = this.w * this.height / this.width;
          this.x = clamp(this.x - this.w / 2 + prevW / 2, 0, this.imgWidth - this.w);
          this.y = clamp(this.y - this.h / 2 + prevH / 2, 0, this.imgHeight - this.h);
        }
      }
    },
    zoomFactor() {
      return Math.max(1, this.height * this.imgWidth / (this.width * this.imgHeight));
    },
    maxZoom() {
      return Math.max(this.zoom, 300 * this.zoomFactor);
    },
    minZoom() {
      return 100 * this.zoomFactor;
    },
    videoSrc() {
      const { clippingEffect } = this;
      if (clippingEffect && clippingEffect.type === 'video') {
        return clippingEffect.content.src;
      }
      return '';
    },
    imageSrc() {
      const { clippingEffect } = this;
      if (!clippingEffect) {
        return '';
      }
      const efc = clippingEffect.content;
      switch (clippingEffect.type) {
        case 'image':
          return efc.src;
        case 'video': {
          if (!this.videoDuration) {
            break;
          }
          const progressTime = clamp(this.$store.state.currentProgress - this.activeFragment.start, 0, clippingEffect.duration) / 1e3;
          const playbackRate = clamp(+efc.playbackRate || 1, .1, 10);
          const usedProgress = progressTime * playbackRate;
          let time = 0;
          const { loop, crop } = efc;
          if (loop) {
            const period = crop ? crop[1] - crop[0] : this.videoDuration;
            const start = crop ? crop[0] : 0;
            time = usedProgress % period + start;
          } else if (crop) {
            time = Math.min(usedProgress + crop[0], crop[1]);
          } else {
            time = usedProgress;
          }

          return efc.src + `?x-oss-process=video/snapshot,t_${Math.round(time * 1e3)}`;
        }
      }
      return '';
    }
  },
  methods: {
    reset() {
      if (this.clippingEffect) {
        const efc = this.clippingEffect.content;
        this.top = efc.top;
        this.left = efc.left;
        this.width = efc.width;
        this.height = efc.height;
      }
      if (this.value) {
        this.x = this.value.x;
        this.y = this.value.y;
        this.w = this.value.w;
        this.h = this.value.h;
      }
      console.log('resetting');
    },
    getResizeCursor(dir) {
      if (this.clippingEffect && this.clippingEffect.content) {
        let rotation = this.clippingEffect.content.rotate;
        if (this.containerEffect) {
          rotation += this.containerEffect.content.rotate || 0;
        }
        switch (dir) {
          case 'tl':
          case 'br':
            rotation += 45;
            break;
          default:
            rotation += 135;
        }

        switch (Math.round((rotation + 180) % 180 / 45)) {
          case 0:
          case 4:
            return 'ew-resize';
          case 1:
            return 'nwse-resize';
          case 2:
            return 'ns-resize';
          case 3:
            return 'nesw-resize';
        }
      }
      return 'default';
    },
    handleMouseDown(e, dir) {
      this.dragging = {
        dir,
        clientX: e.clientX,
        clientY: e.clientY,
        x: this.left,
        y: this.top,
        w: this.width,
        h: this.height
      }
      document.body.classList.add('unselectable');
      document.addEventListener('mousemove', this.handleMouseMove);
      document.addEventListener('mouseup', this.handleMouseUp);
    },
    handleMouseMove(e) {
      if (this.dragging) {
        let deltaX = (e.clientX - this.dragging.clientX) / this.scale;
        let deltaY = (e.clientY - this.dragging.clientY) / this.scale;
        let hb, vb;
        // let preserve = false;
        let actualDir = this.dragging.dir;
        const { containerEffect, clippingEffect } = this;

        if (actualDir) {
          const efRotate = this.clippingEffect.content.rotate;
          if (efRotate) {
            const unrotatedDelta = rotateBy({ x: deltaX, y: deltaY }, { x: 0, y: 0 }, -efRotate);
            deltaX = unrotatedDelta.x;
            deltaY = unrotatedDelta.y;
          }
        }

        if (containerEffect) {
          const containerEFC = containerEffect.content;
          const unrotatedDelta = rotateBy(
            { x: deltaX, y: deltaY },
            { x: 0, y: 0 },
            (actualDir && containerEFC.flip && containerEFC.flip !== 'none' && 2 * clippingEffect.content.rotate || 0) - containerEFC.rotate
          ); // normalize rotation when flipped.

          deltaX = unrotatedDelta.x;
          deltaY = unrotatedDelta.y;
          switch (containerEFC.flip) {
            case 'horizontal':
              actualDir = actualDir.replace(/[lr]/, t => t === 'l' ? 'r' : 'l');
              deltaX = -deltaX;
              break;
            case 'vertical':
              actualDir = actualDir.replace(/[tb]/, t => t === 't' ? 'b' : 't');
              deltaY = -deltaY;
              break;
          }
        }

        if (e.shiftKey) {
          if (actualDir) {
            // preserve = true;
            const prevRatio = (
              actualDir === 'tr' || actualDir === 'bl' ? -1 : 1
            ) * this.h / this.w;
            deltaY = deltaX * prevRatio;
          } else {
            if (Math.abs(deltaX / deltaY) >= 1) {
              deltaY = 0;
            } else {
              deltaX = 0;
            }
          }
        }

        const ret = {
          x: 0,
          y: 0,
          w: 0,
          h: 0
        };

        const imageScale = this.width / this.w;

        if (this.dragging.dir) {
          switch (this.dragging.dir[0]) {
            case 't': {
              deltaY = clamp(deltaY, -this.y * imageScale, this.dragging.h - 1);
              ret.h = this.dragging.h - deltaY;
              vb = ['b', this.dragging.y + this.dragging.h];
              break;
            }
            case 'b': {
              deltaY = clamp(deltaY, 1 - this.dragging.h, (this.imgHeight - this.y - this.h) * imageScale);
              ret.h = this.dragging.h + deltaY;
              vb = ['t', this.dragging.y];
              break;
            }
          }
          switch (this.dragging.dir[1]) {
            case 'l': {
              deltaX = clamp(deltaX, -this.x * imageScale, this.dragging.w - 1);
              ret.w = this.dragging.w - deltaX;
              hb = ['r', this.dragging.x + this.dragging.w];
              break;
            }
            case 'r': {
              deltaX = clamp(deltaX, 1 - this.dragging.w, (this.imgWidth - this.w - this.x) * imageScale);
              ret.w = this.dragging.w + deltaX;
              hb = ['l', this.dragging.x];
              break;
            }
          }
          // if (this.aspectRatio) {
          //   this.h = this.w / this.aspectRatio;
          //   const maxH = Math.max(1, vb[0] === 't' ? this.height - this.y : vb[1]);
          //   if (this.h > maxH) {
          //     this.h = maxH;
          //     this.w = maxH * this.aspectRatio;
          //   }
          // }
          if (hb[0] === 'r') {
            ret.x = deltaX;
          }
          if (vb[0] === 'b') {
            ret.y = deltaY;
          }
          this.offset = ret;
        } else {
          // TODO:
          this.moveOffset.x = clamp(deltaX, (this.w + this.x - this.imgWidth) * imageScale, this.x * imageScale);
          this.moveOffset.y = clamp(deltaY, (this.y + this.h - this.imgHeight) * imageScale, this.y * imageScale);
        }
      }
    },
    handleMouseUp() {
      if (this.dragging) {
        document.body.classList.remove('unselectable');
        const { x, y, w, h, dir } = this.dragging;
        const efRotate = this.clippingEffect.content.rotate;
        const imageScale = this.w / this.width;
        this.dragging = false;
        if (this.offset) {
          let anchor, nextAnchor;
          const nextEfc = {
            left: x + this.offset.x,
            top: y + this.offset.y,
            width: this.offset.w,
            height: this.offset.h
          }
          if (dir && efRotate) {
            const center = { x: w / 2, y: h / 2 };
            const nextCenter = { x: nextEfc.width / 2, y: nextEfc.height / 2 };
            switch (dir) {
              case 'tr':
                // align bottom left
                {
                  anchor = rotateBy(
                    { x: 0, y: h },
                    center,
                    efRotate
                  );

                  nextAnchor = rotateBy(
                    { x: 0, y: nextEfc.height },
                    nextCenter,
                    efRotate
                  );
                }
                break;
              case 'br':
                // align top left
                {
                  anchor = rotateBy(
                    { x: 0, y: 0 },
                    center,
                    efRotate
                  );

                  nextAnchor = rotateBy(
                    { x: 0, y: 0 },
                    nextCenter,
                    efRotate
                  );
                }
                break;
              case 'bl':
                // align top right
                {
                  anchor = rotateBy(
                    { x: w, y: 0 },
                    center,
                    efRotate
                  );

                  nextAnchor = rotateBy(
                    { x: nextEfc.width, y: 0 },
                    nextCenter,
                    efRotate
                  );
                }
                break;
              case 'tl':
                // align bottom right
                {
                  anchor = rotateBy(
                    { x: w, y: h },
                    center,
                    efRotate
                  );

                  nextAnchor = rotateBy(
                    { x: nextEfc.width, y: nextEfc.height },
                    nextCenter,
                    efRotate
                  );
                }
                break;
            }
            if (anchor) {
              nextEfc.top = y + anchor.y - nextAnchor.y;
              nextEfc.left = x + anchor.x - nextAnchor.x;
            }
          }
          this.top = nextEfc.top;
          this.left = nextEfc.left;
          this.width = nextEfc.width;
          this.height = nextEfc.height;
          this.x += this.offset.x * imageScale;
          this.y += this.offset.y * imageScale;
          this.w = this.offset.w * imageScale;
          this.h = this.offset.h * imageScale;
          this.offset = null;
        }
        this.x -= this.moveOffset.x * imageScale;
        this.y -= this.moveOffset.y * imageScale;
        this.moveOffset = {
          x: 0,
          y: 0
        };
      }
      document.removeEventListener('mousemove', this.handleMouseMove);
      document.removeEventListener('mouseup', this.handleMouseUp);
    },
    handleImageLoad(e) {
      // TODO:
      this.imgWidth = e.target.naturalWidth;
      this.imgHeight = e.target.naturalHeight;
      if (!this.value) {
        this.x = 0;
        this.y = 0;
        this.w = this.imgWidth;
        this.h = this.imgHeight;
      }
    },
    setContainerStyle() {
      const coverBcr = document.getElementById('effectCover').getBoundingClientRect();
      this.containerStyle = {
        margin: 0,
        top: coverBcr.top + 'px',
        left: coverBcr.left + 'px',
        width: coverBcr.width + 'px',
        height: coverBcr.height + 'px'
      };
      this.containerOffset = coverBcr.top;
    },
    formatTooltip(value) {
      return Math.round(value / this.zoomFactor);
    },
    cancel() {
      console.log('cancelling');
      this.$store.commit('handleClipping', false);
      setTimeout(() => {
        this.$store.commit('handleClippingEffect', null);
      }, 300);
    },
    done() {
      const clip = {
        x: this.x,
        y: this.y,
        w: this.w,
        h: this.h
      };
      this.$set(this.clippingEffect.content, 'clip', clip);
      ['top', 'left', 'width', 'height'].forEach(k => {
        this.$set(this.clippingEffect.content, k, this[k]);
      });
      requestAnimationFrame(this.cancel);
    }
  },
  watch: {
    resetMarker() {
      if (this.visible) {
        this.setContainerStyle();
        this.reset();
      } else {
        setTimeout(() => {
          this.imgWidth = 0;
          this.imgHeight = 0;
        }, 300);
      }
    },
    async videoSrc(val) {
      if (val) {
        this.videoDuration = await getVideoDuration(val);
      }
    }
  },
  mounted() {
    document.addEventListener('keydown', e => {
      if (this.visible) {
        switch (e.keyCode) {
          case 27:
            this.cancel();
            break;
          case 13:
            this.done();
            break;
        }
      }
    });
    window.addEventListener('resize', () => {
      if (this.visible) {
        this.setContainerStyle();
      }
    });
  }
}
</script>
<style src="./ImageCropModal.vue"/>
<style>
.inline-image-cropper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  transition: 0.3s;
}

.inline-image-cropper--hidden {
  visibility: hidden;
  opacity: 0;
}

.inline-image-cropper__container {
  position: absolute;
}

.inline-image-cropper__image {
  transition: opacity 0.2s, visibility 0.2s;
  position: absolute;
  pointer-events: none;
}

.inline-image-cropper__controls {
  position: absolute;
  background: #fff;
  z-index: 1;
  display: flex;
  align-items: center;
  width: 320px;
  height: 32px;
  border-radius: 2px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08), 0 0 4px rgba(0, 0, 0, 0.1);
  padding: 0 8px;
  transition: opacity 0.2s, visibility 0.2s;
}

.inline-image-cropper__btn {
  margin: 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.inline-image-cropper--loading .inline-image-cropper__image,
.inline-image-cropper--loading .inline-image-cropper__controls {
  visibility: hidden;
  opacity: 0;
}

.inline-image-cropper--loading .effect-cover__handle {
  display: none;
}

.image-crop-modal__spinner {
  visibility: hidden;
  background: rgba(255, 255, 255, 0.4);
  opacity: 0;
  transition: 0.3s 0.3s;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #007eff;
}

.inline-image-cropper--loading .image-crop-modal__spinner {
  visibility: visible;
  opacity: 1;
  transition-delay: 0s;
}
</style>